/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section3_TitleInputs */

const en_terms_section3_title = /** @type {(inputs: Terms_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use of the Service`)
};

const ko_terms_section3_title = /** @type {(inputs: Terms_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서비스 이용`)
};

const ja_terms_section3_title = /** @type {(inputs: Terms_Section3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスの利用`)
};

/**
* | output |
* | --- |
* | "Use of the Service" |
*
* @param {Terms_Section3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section3_title = /** @type {((inputs?: Terms_Section3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section3_title(inputs)
	if (locale === "ko") return ko_terms_section3_title(inputs)
	return ja_terms_section3_title(inputs)
});